// ---------------------------------------------- modules import
import { AuthAction, AuthActionType } from "./common";

// ---------------------------------------------- action creators
class Actions {
  static loginSuccess = (): AuthAction => ({
    type: AuthActionType.LOGIN_SUCCESS
  });

  static loginError = (error: string): AuthAction => ({
    type: AuthActionType.LOGIN_ERROR,
    payload: {
      error
    }
  });

  static logoutSuccess = (): AuthAction => ({
    type: AuthActionType.LOGOUT_SUCCESS
  });

  static logoutError = (error: string): AuthAction => ({
    type: AuthActionType.LOGOUT_ERROR,
    payload: {
      error
    }
  });
}

export default Actions;
